var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('HeaderComponent'),_c('JoinComponent'),_c('FooterComponents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }